import { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import HomeDevelopment from './HomeDevelopment';
import HomeProduction from './HomeProduction';

const Home = () => {
  return (
    <Fragment>
      {import.meta.env.VITE_NODE_ENV === 'development' ? (
        <HomeDevelopment />
      ) : (
        <HomeProduction />
      )}
    </Fragment>
  );
};
export default observer(Home);
